// extracted by mini-css-extract-plugin
module.exports = {"sample_maintenance_chart_block_wrapper":"ChartBlock_sample_maintenance_chart_block_wrapper__veDb9"};